import { companyInfo, navLinks } from '../../../mocks/homeData';

const Footer = () => {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-stone-800 text-white">
      <div className="max-w-7xl mx-auto px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-7 h-7 flex items-center justify-center">
                <i className="ri-building-2-line text-amber-400 text-xl" />
              </div>
              <span className="font-bold text-lg tracking-wide">{companyInfo.name}</span>
            </div>
            <p className="text-stone-400 text-sm leading-relaxed mb-5">
              深耕台中逾20年，專業木工裝修施工，以品質與誠信為本，打造每位客戶的理想生活空間。
            </p>
            <div className="flex gap-3">
              {[
                { icon: 'ri-facebook-box-line', label: 'Facebook' },
                { icon: 'ri-line-line', label: 'LINE' },
                { icon: 'ri-instagram-line', label: 'Instagram' },
              ].map((social) => (
                <a
                  key={social.label}
                  href="#"
                  aria-label={social.label}
                  rel="nofollow noopener"
                  className="w-9 h-9 flex items-center justify-center rounded-lg border border-stone-600 text-stone-400 hover:text-amber-400 hover:border-amber-400 transition-colors cursor-pointer"
                >
                  <i className={`${social.icon} text-base`} />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-sm mb-5 text-stone-300 tracking-wide">快速導覽</h4>
            <ul className="flex flex-col gap-3">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                    className="flex items-center gap-2 text-stone-400 text-sm hover:text-amber-400 transition-colors cursor-pointer"
                  >
                    <div className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-arrow-right-s-line text-xs" />
                    </div>
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-sm mb-5 text-stone-300 tracking-wide">聯絡資訊</h4>
            <ul className="flex flex-col gap-4">
              <li className="flex items-start gap-3">
                <div className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-phone-line text-amber-400 text-sm" />
                </div>
                <div>
                  <a href={`tel:${companyInfo.phone.replace(/-/g, '')}`} className="text-stone-300 text-sm hover:text-amber-400 transition-colors cursor-pointer block">
                    {companyInfo.phone}（市話）
                  </a>
                  <a href={`tel:${companyInfo.mobile.replace(/-/g, '')}`} className="text-stone-300 text-sm hover:text-amber-400 transition-colors cursor-pointer block">
                    {companyInfo.mobile}（手機）
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-amber-400 text-sm" />
                </div>
                <span className="text-stone-300 text-sm">{companyInfo.address}</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-time-line text-amber-400 text-sm" />
                </div>
                <span className="text-stone-300 text-sm">週一至週六 08:00 – 18:00</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-stone-700">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-stone-500 text-xs">
            © 2026 {companyInfo.name}. All rights reserved.
          </p>
          <p className="text-stone-500 text-xs">
            台中市太平區 · 專業木工室內裝修
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
